// extracted by mini-css-extract-plugin
export default {"cls1":"useAttachment-cls1___b86422fdd278add6be9","cls2":"useAttachment-cls2__ed9044a9a8b05e1dbae2 useAttachment-cls1___b86422fdd278add6be9"};